import { Box, Tooltip, styled } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { PoolButton } from '@synergy/components-next';
import { ReactElement, useEffect, useState } from 'react';
import { SortingArrowUpIcon } from '@synergy/theme-next';

export interface ScrollToTopIconProps {
    showBelow: number;
}

const StyledBox = styled(Box)(({ theme }) => ({
    zIndex: theme.zIndex.fab,
    position: 'fixed',
    bottom: '2vh',
    right: '2%',
}));

export const ScrollToTopIcon = (props: ScrollToTopIconProps): ReactElement | null => {
    const { showBelow } = props;

    const [show, setShow] = useState(false);

    useEffect(() => {
        if (showBelow) {
            window.addEventListener('scroll', handleScroll);
            return () => window.removeEventListener('scroll', handleScroll);
        }
        return;
    });

    const handleScroll = (): void => {
        if (window.scrollY > showBelow) {
            if (!show) setShow(true);
        } else {
            if (show) setShow(false);
        }
    };

    const handleClick = (): void => {
        window['scrollTo']({ top: 0, behavior: 'smooth' });
    };

    return (
        <div>
            {show && (
                <StyledBox>
                    <Tooltip title={<FormattedMessage id="app.footer.mobile.top.navigateToTop" />} placement="top">
                        <div>
                            <PoolButton
                                color="primary"
                                variant="containedRound"
                                startIcon={<SortingArrowUpIcon />}
                                onClick={handleClick}
                            />
                        </div>
                    </Tooltip>
                </StyledBox>
            )}
        </div>
    );
};
